class LazyModal extends HTMLElement {
  constructor() {
    super();

    this.id = this.getAttribute("id");
    this.type = this.getAttribute("type");

    this.overlay = this.querySelector(".overlay");
    this.modalContent = this.querySelector(".content");

    this.btns = document.querySelectorAll(`.modal-btns-${this.id}`);

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.btns.forEach((btn) => {
      btn.addEventListener("click", () => this.openModal(btn.id));
    });

    this.overlay.addEventListener("click", this.closeModal);

    // Evitar que el evento se propague desde .content hacia .overlay
    this.modalContent.addEventListener("click", (event) => {
      event.stopPropagation();
    });
  }

  openModal(btnId) {
    if (this.type === "blog") {
      this.img = this.querySelector("img");
      this.subheader = this.querySelector("h5");
      this.header = this.querySelector("h4");
      this.text = this.querySelector("p");
      this.btn1 = this.querySelector("a.a-1");
      this.btn2 = this.querySelector("a.a-2");
    } else if (this.type === "img") {
      this.img = this.querySelector("img");
    }

    this.btns.forEach((btn) => {
      if (this.type !== "call_us" && this.type !== "accordion" && btn.id === btnId) {
        const info = JSON.parse(btn.dataset.info);
        if (this.type === "blog") {
          const {
            img,
            text,
            header,
            subheader,
            btn_label_1,
            btn_label_2,
            btn_url_1,
            btn_url_2,
          } = info;
          this.img.srcset = img;
          this.subheader.innerHTML = subheader;
          this.header.innerHTML = header;
          this.text.innerHTML = text;
          this.btn1.innerHTML = btn_label_1;
          this.btn1.href = btn_url_1;
          this.btn2.innerHTML = btn_label_2;
          this.btn2.href = btn_url_2;
          this.dispatchEvent(
            new CustomEvent("updatePopupHref", {
              bubbles: true,
            })
          );
        } else if (this.type === "img") {
          const { img } = info;
          this.img.src = img;
        }
      }
    });
    this.overlay.classList.remove("hidden");
    setTimeout(() => {
      this.overlay.classList.add("show");
      this.modalContent.classList.add("show");
    }, 100);
  }

  closeModal() {
    this.overlay.classList.remove("show");
    this.modalContent.classList.remove("show");
    setTimeout(() => {
      this.overlay.classList.add("hidden");
    }, 100);
  }
}

customElements.define("lazy-modal", LazyModal);
